const USER_ROLE = Object.freeze({
  ADMIN: 'admin',
  DOCTOR: 'doctor',
  PATIENT: 'patient',
  NURSE: 'nurse',
  RECEPTIONIST: 'receptionist',
});

module.exports = { USER_ROLE };
